
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeLaborGrid extends Serenity.EntityGrid<ECommExchangeLaborRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchangeLabor'; }
        protected getIdProperty() { return ECommExchangeLaborRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeLaborRow.localTextPrefix; }
        protected getService() { return ECommExchangeLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}